import { observer } from 'mobx-react-lite';
import { useDate } from 'state';
import prependString from 'helpers/prependString';
import { Txt } from '../index';

/**
 * DateTime
 *
 * @return {JSX.Element}
 */
const DateTime = () => {
  const { value: date } = useDate();

  return (
    <>
      <Txt mm>
        {prependString(date.getHours())}:{prependString(date.getMinutes())}
      </Txt>
      <Txt mm>
        {date.getDate()}/{prependString(date.getMonth() + 1)}/
        {date.getFullYear()}
      </Txt>
    </>
  );
};

DateTime.displayName = 'DateTime';

export default observer(DateTime);
